import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert } from 'lucide-react';
export function Trust() {
  return <section className="py-16 bg-white border-y border-brand-beige" data-id="element-161">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col md:flex-row gap-8 items-start md:items-center bg-brand-cream p-8 rounded-2xl" data-id="element-163">
          <div className="flex-shrink-0 bg-brand-beige p-4 rounded-full" data-id="element-164">
            <ShieldAlert className="w-8 h-8 text-brand-gold" data-id="element-165" />
          </div>

          <div data-id="element-166">
            <h2 className="text-xl font-heading font-bold text-brand-green mb-3" data-id="element-167">
              Compra informada y responsable
            </h2>
            <p className="text-brand-brown/80 mb-4 text-sm leading-relaxed" data-id="element-168">
              Queremos que elijas con claridad. Por eso te orientamos por
              WhatsApp antes de comprar, explicando disponibilidad, formato,
              forma de uso sugerida y condiciones reales del producto.
            </p>
            <div className="bg-white p-4 rounded-xl border border-brand-beige/50 text-xs text-brand-brown/60 leading-relaxed" data-id="element-169">
              <strong data-id="element-170">Aviso importante:</strong> Este producto es un complemento
              de bienestar. No es medicamento. No reemplaza diagnóstico,
              tratamiento ni indicación médica. Si estás embarazada, en
              lactancia, tienes una condición médica o tomas medicamentos,
              consulta con un profesional de salud.
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}